<template>
  <div class="operation_box">
    <template v-for="item in iconList">
      <span :key="item.iconName" class="margin_r pointer" @click="clickItem(item)">
        <i :class="`fa font_lg  ${item.iconName} ${item.colorName}`"></i>
      </span>
    </template>
  </div>
</template>
<script>

export default {
  data() {
    return {
      iconList: [
        { type: "edit", iconName: "fa-pencil", colorName: "secondary_color" },
        { type: "del", iconName: "fa-trash-o", colorName: "secondary_color" }
      ]
    };
  },
  methods: {
    clickItem(data) {
      let { colDef } = this.params;
      if (data.type === "edit") {
		  this.params.editFun(this.params.data);
      }
      if (data.type == "del") {
		  this.params.delFun(this.params.data);
      }
    }
  }
};
</script>
